import { get, post, put, patch, del } from '../http/http';
// 我的账单
export default {
    getList: (val) => get('/order/person', val) // 查询列表
}